import styled, { css } from 'styled-components';
import { focusRing, loadAnimation } from '../../../styles/mixins';

export const OpenxUiCardDetailsLeftFlight = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
  text-align: left;
  position: absolute;
  color: #080808;
  bottom: 30.5px;
  @media only screen and (min-width: 1024px) {
    position: unset;
    color: #fff;
  }
`;

export const OpenxUiCardContent = styled.div<{ isMapCard?: boolean }>`
  width: 100%;
  height: calc(100% - 61px);
  //transition: all 0.3s ease-in-out;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0) no-repeat center;
  background-size: cover;

  @media only screen and (min-width: 1024px) {
    height: 100%;
    background-image: unset !important;
  }

  .openx-ui-card-details-desk,
  .openx-ui-card-details-mobile {
    position: absolute;
    bottom: 61px;
    left: 0;
    width: 100%;
    padding: 15px;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .openx-ui-card-details-desk {
    display: none;
    @media only screen and (min-width: 1024px) {
      flex-direction: row;
      bottom: 0;
      display: flex;
    }
  }

  .openx-ui-card-details-mobile {
    @media only screen and (min-width: 1024px) {
      display: none;
    }
  }
`;

export const OpenxUiCard = styled.a<{ isMapCard?: boolean }>`
  &.openx-ui-card {
    position: relative;
    width: 100%;
    height: 343px;
    font-size: 14px;
    color: #fff;

    display: block;
    margin: 0 0 16px;
    border: none;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.3s;
    z-index: 0;

    &:focus-visible {
      ${focusRing}
    }

    &:hover {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }

    ${({ isMapCard }) =>
      isMapCard
        ? css`
            background: #7fd8d5 no-repeat center 17px;
          `
        : ''};

    .openx-ui-card-details-right {
      position: relative;
      height: 61px;
      width: calc(100% - 30px);
      background-color: #fff;
      color: #080808;
      margin: 0 auto;
    }

    @media only screen and (min-width: 1024px) {
      .openx-ui-card-details-right {
        position: absolute;
        bottom: 15px;
        right: 15px;
        background-color: unset;
        color: #fff;
      }
    }
  }

  @media only screen and (min-width: 768px) {
    &.openx-ui-card {
      width: calc(((100% - 32px) / 3));
      height: 250px;
    }

    &.openx-ui-tile-7,
    &.openx-ui-tile-8,
    &.openx-ui-tile-16 {
      width: calc((((100% - 32px) / 3) * 2) + 16px);
    }

    &.openx-ui-tile-4,
    &.openx-ui-tile-5,
    &.openx-ui-tile-13,
    &.openx-ui-tile-14 {
      width: calc((((100% - 32px) / 3) * 1.5) + 8px);
    }

    .openx-ui-card-details-left-expand .openx-ui-card-details-left-city {
      width: 100%;
    }

    .openx-ui-main-lessitem {
      justify-content: flex-start;
    }

    .openx-ui-main-lessitem .openx-ui-card {
      margin-right: 16px;
    }
  }

  @media only screen and (min-width: 1024px) {
    &.openx-ui-card {
      height: 298px;
    }

    .openx-ui-card-details-left-expand .openx-ui-card-details-left-city {
      width: 100%;
    }
  }

  @media only screen and (min-width: 1240px) {
    &.openx-ui-card {
      width: calc(((100% - 48px) / 4));
    }

    &.openx-ui-tile-9,
    &.openx-ui-tile-11,
    &.openx-ui-tile-16 {
      width: calc((((100% - 48px) / 4) * 2) + 16px);
    }

    &.openx-ui-tile-5,
    &.openx-ui-tile-7 {
      width: calc((((100% - 48px) / 4) * 1.5) + 8px);
    }

    .openx-ui-card-details-left-expand .openx-ui-card-details-left-city {
      width: 100%;
    }
  }

  &.openx-ui-card-loading {
    background: #fff;
    box-shadow: ${({ theme }): string => theme.kallisto.shadow.mediumDownShadow};
    border-radius: 9px;

    .openx-ui-card-loading-title {
      position: absolute;
      width: 80px;
      height: 24px;
      left: 15px;
      top: 15px;
      border-radius: 4px;

      ${loadAnimation}
    }

    .openx-ui-card-loading-left-big {
      position: absolute;
      width: 110px;
      height: 24px;
      left: 15px;
      bottom: 35px;
      border-radius: 4px;

      ${loadAnimation}
    }

    .openx-ui-card-loading-left-small {
      position: absolute;
      width: 60px;
      height: 12px;
      left: 15px;
      bottom: 20px;
      border-radius: 4px;

      ${loadAnimation}
    }

    .openx-ui-card-loading-right-big {
      position: absolute;
      width: 48px;
      height: 24px;
      right: 15px;
      bottom: 35px;
      border-radius: 4px;

      ${loadAnimation}
    }

    .openx-ui-card-loading-right-small {
      position: absolute;
      width: 34px;
      height: 12px;
      right: 15px;
      bottom: 20px;
      border-radius: 4px;

      ${loadAnimation}
    }
  }
`;

export const OpenxUiCardGradient = styled.div<{ isMapCard?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: background 0.3s ease-in-out;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
`;

export const OpenxUiCardBackground = styled.div<{ isMapCard?: boolean }>`
  position: relative;
  width: 100%;
  height: calc(100% - 61px);

  > img {
    width: 100%;
    height: 100%;
    object-position: top;
    object-fit: cover;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);

    @media (min-width: 1024px) {
      height: 100%;
    }
  }

  @media (min-width: 1024px) {
    height: 100%;
    &:hover ${OpenxUiCardGradient} {
      background: rgba(0, 0, 0, 0.5);
    }
  }
`;

export const OpenxUiCardDetailsLeft = styled.div`
  position: absolute;
  transition: all 0.3s;
  width: 100%;
  margin: 0 auto;

  @media only screen and (min-width: 768px) {
    position: relative;
    height: 20px;
  }

  @media only screen and (min-width: 1024px) {
    position: absolute;
    height: 45px;
    bottom: 15px;
    left: 15px;
    width: calc(100% - 30px);
  }

  &.openx-ui-card-details-left-expand {
    height: 158px;
  }
`;

export const OpenxUiCardDetailsBottomMobile = styled.div`
  height: 61px;
  padding: 0 16px;
  width: 100%;
  background-color: #fff;
  color: #080808;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  left: 0;

  @media only screen and (min-width: 1024px) {
    display: none;
  }
`;

export const MapImage = styled.img`
  width: 100%;
  height: calc(100% - 61px);
  object-fit: cover;
`;

export const MapCard = styled.div`
  position: absolute;
  bottom: 0px;
  color: rgb(8, 8, 8);
  height: 61px;
  padding: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  width: 100%;

  @media only screen and (min-width: 1024px) {
    height: 70px;
    padding: 15px;
  }

  div {
    font-size: 13px;
    line-height: 18px;
  }

  button {
    min-width: 80px;
    height: 38px;
    background: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
    color: #fff;
    border: none;
    border-radius: 6px;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;
    margin-left: 15px;

    @media only screen and (min-width: 1024px) {
      height: 40px;
    }
  }
`;
